import {pristineNavigation} from "../../@pristine/types";

export const navigation: pristineNavigation[] = [
  {
    id: 'User_Menu',
    title: 'Menu',
    translate: 'NAV.APPLICATIONS',
    type: 'group',
    icon: 'apps',
    children: []
  }
];
